// The people (and the team) credited on the guides: the author box, the "Reviewed by" line, the authors section on
// /guides and the Article JSON-LD all read this list. Never invent a person or a credential: an entry with
// `placeholder: true` is a gap for the owner to fill in, shown as TODO on staging, and guides.test.tsx refuses to
// let a guide that credits one go live in prod (GUIDES_IN_PROD).

export interface GuideAuthor {
  /** Used in front matter (author / reviewer) and as the anchor on /guides (#author-<id>). */
  id: string;
  /** "person" is marked up as a schema.org Person; "team" as Photohawk's Organization. */
  kind: "person" | "team";
  name: string;
  role: string;
  bio: string;
  /** Optional profile links (LinkedIn etc.), for JSON-LD sameAs. */
  sameAs?: string[];
  /** True while the entry is a TODO for the owner (no real name, role or bio yet). */
  placeholder?: boolean;
}

export const GUIDE_AUTHORS: GuideAuthor[] = [
  {
    id: "photohawk-team",
    kind: "team",
    name: "Photohawk team",
    role: "The people who build and run Photohawk",
    bio: "We build Photohawk, the platform event photos are shared and sold on, and we answer its support inbox. These guides come from what we see every week: how galleries are set up, how people search for their photos and what they ask us when something goes wrong.",
  },
  // A named founder entry (id "founder", kind "person") can be added here with a real name, role and bio; the guides
  // went live on 21 Oct 2026 credited to the team instead of an unfilled placeholder.
];

export const findAuthor = (id: string | undefined): GuideAuthor | undefined => GUIDE_AUTHORS.find((a) => a.id === id);

/** The anchor for an author on the hub page. */
export const authorAnchor = (id: string) => `author-${id}`;
